(function () {
  function initProduct(root) {
    if (!root || root.dataset.ferrerProductInit === "true") return;
    root.dataset.ferrerProductInit = "true";

    var form = root.querySelector("form[action*='/cart/add']");
    var variantInput = root.querySelector("[data-ferrer-variant-input]");
    var priceEl = root.querySelector("[data-ferrer-price]");
    var mainImage = root.querySelector(".gallery__main img");
    var submitButton = form ? form.querySelector("[type='submit']") : null;

    root.querySelectorAll("[data-ferrer-gallery-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var url = thumb.getAttribute("data-ferrer-image-url");
        if (url && mainImage) mainImage.src = url;
        root.querySelectorAll(".gallery__thumb").forEach(function (item) {
          item.classList.remove("is-active");
        });
        thumb.classList.add("is-active");
      });
    });

    root.querySelectorAll("[data-ferrer-variant-option]").forEach(function (option) {
      option.addEventListener("change", function () {
        if (!option.checked) return;

        if (variantInput) variantInput.value = option.value;

        var formatted = option.getAttribute("data-formatted-price");
        if (priceEl && formatted) priceEl.textContent = formatted;

        if (submitButton) {
          submitButton.disabled = option.disabled;
          submitButton.textContent = option.disabled
            ? submitButton.getAttribute("data-sold-out-label") || "Esgotado"
            : submitButton.getAttribute("data-add-label") || "Adicionar à sacola";
        }
      });
    });

    if (submitButton) {
      submitButton.setAttribute("data-add-label", submitButton.textContent.trim());
    }
  }

  function syncCartQtyInputs() {
    var desktop = window.matchMedia("(min-width: 56rem)").matches;
    document.querySelectorAll("[data-ferrer-cart-qty-mobile]").forEach(function (input) {
      input.disabled = desktop;
    });
    document.querySelectorAll("[data-ferrer-cart-qty-desktop]").forEach(function (input) {
      input.disabled = !desktop;
    });
  }

  function initCartQty() {
    syncCartQtyInputs();
    if (!window.__ferrerCartQtyMediaBound) {
      window.__ferrerCartQtyMediaBound = true;
      window.matchMedia("(min-width: 56rem)").addEventListener("change", syncCartQtyInputs);
    }

    document.querySelectorAll("[data-ferrer-cart-qty]").forEach(function (input) {
      if (input.dataset.ferrerCartQtyInit === "true") return;
      input.dataset.ferrerCartQtyInit = "true";
      input.addEventListener("change", function () {
        if (input.disabled) return;
        var form = input.closest("form");
        if (form) form.submit();
      });
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll("[data-ferrer-product]").forEach(initProduct);
    initCartQty();
  }

  document.addEventListener("DOMContentLoaded", function () {
    boot(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    boot(event.target);
  });
})();
